import { FC } from "react";
import { Flex, Tag } from "antd";
import { useAntToken } from "@hooks/common/useAntToken";
import { useBreakpoints } from "@hooks/common/useBreakPoints";

interface IManagerTypeTagProps {
  isRegional: boolean | undefined;
}
const ManagerTypeTag: FC<IManagerTypeTagProps> = ({ isRegional }) => {
  const { token } = useAntToken();
  const { isScreenXS } = useBreakpoints();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const fontWeightMedium = token.fontWeightMedium;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const fontSizeXS = token.fontSizeXS;
  const commonStyles = {
    boxShadow: token.boxShadow,
    fontWeight: fontWeightMedium,
    fontSize: isScreenXS ? fontSizeXS : token.fontSize
  };

  const commonFlexStyles = {
    height: "24px",
    width: "104px"
  };
  return (
    <>
      {isRegional ? (
        <Flex justify={"start"} align="middle" style={commonFlexStyles}>
          <Tag
            bordered={true}
            color={token.colorSuccess}
            style={{
              ...commonStyles,
              background: token.colorSuccessBgHover,
              color: token.colorText
            }}>
            Regional
          </Tag>
        </Flex>
      ) : (
        <Flex justify={"start"} align="middle" style={commonFlexStyles}>
          <Tag
            bordered={true}
            color="error"
            style={{
              ...commonStyles,
              background: "rgba(177,174,174,0.69)",
              color: token.colorText,
              border: "none"
            }}>
            Property
          </Tag>
        </Flex>
      )}
    </>
  );
};

export default ManagerTypeTag;
